<template>
  <div class="container py-4">
    <router-view />
  </div>
</template>
